const moment = require('moment');
const { dateFormat } = require("../../constants/Formatos");

const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
];
/**
 * Devuelve la diferencia de días entre dos fechas
 * @param {*} initDate
 * @param {*} endDate
 * @returns
 */
const daysBetweenDates = (initDate, endDate) => {
    let days = NaN;
    try {
        const init = moment(initDate);
        const end = moment(endDate);
        days = end.diff(init, "days");
    } catch (error) {
        console.debug(
            "Error en rango de fechas proporcionado",
            initDate,
            endDate,
            error
        );
    }
    return days;
}

/**
 * Valida que el valor de fecha proporcionado corresponda con el formato de fecha especificado
 * @param {*} fecha 
 * @param {*} formato 
 * @returns 
 */
 const isValidDate = (fecha, formato) => {
    var m = moment(fecha, formato || dateFormat, true);
    return m.isValid();
}
/**
 * Obtiene un objeto con el inicio y fin de la semana actual
 * @returns 
 */
const getSemanaActual = () =>{
    const inicial = moment().startOf("isoWeek").format(dateFormat);
    const final = moment(inicial).add(6, "days").format(dateFormat);
    return {inicial, final};
}

/**
 * Obtiene la fecha despues de agregar N cantidad de días
 * @param {string} fecha formateada en string
 * @param {number} dias 
 * @returns 
 */
 const addDays = (fecha, dias) => {
    return moment(fecha, dateFormat).add(dias, "days").format(dateFormat)
}

/**
 * Obtiene la fecha despues de agregar N cantidad de días
 * @param {string} fecha formateada en string
 * @param {number} años 
 * @returns 
 */
const addYears = (fecha, años) => {
    return moment(fecha, dateFormat).add(años, "years").format(dateFormat)
}

/**
 * Obtiene la fecha despues de agregar N cantidad de días
 * @param {string} fecha formateada en string
 * @param {number} años 
 * @param {string} formato
 * @returns 
 */
const addYearsFormat = (fecha, años, formato = formatDate) => {
    return moment(fecha, formato).add(años, "years").format(formato)
}

/**
 * Obtiene la fecha actual en el formato especificado
 * @param {string} formato 
 * @returns 
 */
const getCurrentDate = (formato = dateFormat) => {
    return moment(new Date()).format(formato)
}

/**
 * Formatea una fecha con el formato especificado
 * @param {string} formato 
 * @returns 
 */
const formatDate = (fecha, formato = dateFormat) => {
    return moment(fecha).format(formato)
}

/**
 * Convierte una fecha con formato DD/MMM/YYYY a español
 * @param {string} formato 
 * @returns 
 */
const convertDateToSpanish = (fecha) => {
    const fechaMoment = moment(fecha, "DD/MMM/YYYY");
    if(fechaMoment.isValid){
        fecha = fecha.split("/");
        const mes = meses[fechaMoment.month()].toLowerCase().substring(0, 3);
        return `${fecha[0]}/${mes}/${fecha[2]}`;
    }
    return fecha;
}
const convertMonthToSpanish = (fecha) => {
    const fechaMoment = moment(fecha, "DD/MMM/YYYY");
    if(fechaMoment.isValid){
        return meses[fechaMoment.month()];
    }
    return fecha;
}
module.exports = {
    daysBetweenDates,
    isValidDate,
    getSemanaActual,
    addDays,
    addYears,
    addYearsFormat,
    getCurrentDate,
    formatDate,
    convertDateToSpanish,
    convertMonthToSpanish,
    meses
}

